import { Divider, Grid } from "@mui/material";
import { BaseButton } from "../../../common/base-button/base-button";
import { TickCircle } from "iconsax-react";
import { useTranslation } from "react-i18next";
import "./availability-notification-result.scss";
import { useNavigate } from "react-router";
import { useContext } from "react";
import { LocaleContext } from "../../../../routing/LangRouter";

export default function AvailabilityNotificationResult({ date, hour }) {
    //general variables
    const navigate = useNavigate();
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();

    return (
        <Grid className="notification-result" container justifyContent="center" alignItems="center">
            <Grid container item xs={11} md={8} rowGap={3} className={`notification-result__card `}>
                <Grid
                    container
                    item
                    xs={12}
                    sx={{
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "var(--primary-color-10)",
                        p: 2,
                        borderRadius: 2,
                    }}
                >
                    <TickCircle color="var(--primary-color)" />
                    <span className={`notification-result__card-title`}>{t("Messages.Success Notification")}</span>
                </Grid>

                <Grid
                    container
                    item
                    xs={12}
                    rowGap={2}
                    sx={{
                        p: { xs: 1 },
                    }}
                >
                    <span className={`notification-result__card-body`}>{t("Messages.Valid Until Notification", { date, hour })}</span>
                </Grid>
                <Divider width="100%" />
                <Grid container item xs={12} justifyContent="space-evenly" rowGap={2}>
                    <Grid container item xs={8} md={5}>
                        <BaseButton
                            text={t("backToHomePage")}
                            color="outline"
                            radius="radius-10"
                            size="medium"
                            handleClick={() => navigate(`/${locale}`)}
                        />
                    </Grid>
                    <Grid container item xs={8} md={5}>
                        <BaseButton
                            text={t("General.Tracking")}
                            color="primary"
                            radius="radius-10"
                            size="medium"
                            handleClick={() => navigate(`/${locale}/user-panel/smart-reservation`)}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}
